import { withAuthGate } from '@sunrise-ui/composites';
import { useSafeLocalSearchParams } from '@sunrise-ui/primitives';
import IntroRecordView from '@templates/IntroRecordView';
import { defaultBack } from '@utils/navigation';
import { router } from 'expo-router';
import React from 'react';

function IntroRecordScreen() {
  const { introId } = useSafeLocalSearchParams<{ introId: string }>();

  return (
    <IntroRecordView
      onRecordingFinished={(uri) => {
        router.navigate(`/intros/myIntros/preview/${introId}?uri=${uri}`);
      }}
      handleBack={defaultBack(`/intros/myIntros/prep/${introId}`)}
    />
  );
}

export default withAuthGate(IntroRecordScreen);
